import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import Warning from './Warning';

const WarningBeforeTimeout = ({
  activities,
  sessionConfig,
  showTimeoutOverlay,
  setShowTimeoutOverlay,
  setShowModalConfirm,
  timerVar,
  setTimerVar
}) => {
  const [durationOfSilence, setDurationOfSilence] = useState(0);
  const [remainingWarningSec, setRemainingWarningSec] = useState(0);
  const [warningOn, setWarningOn] = useState(false);
  const [lastActivityTimestamp, setLastActivityTimestamp] = useState(null);
  const lastActivityTimestampRef = useRef(lastActivityTimestamp);
  lastActivityTimestampRef.current = lastActivityTimestamp;
  const warningOnRef = useRef(warningOn);
  warningOnRef.current = warningOn;

  const TIMEOUT_SEC = /^\d+$/.test(parseInt(sessionConfig.timeoutSec, 10))
    ? parseInt(sessionConfig.timeoutSec, 10)
    : -1;
  const WARNING_SEC = /^\d+$/.test(parseInt(sessionConfig.warningSec, 10))
    ? parseInt(sessionConfig.warningSec, 10)
    : -1;

  const DEBUG_MODE = false;

  useEffect(
    () => {
      if (TIMEOUT_SEC === -1 || WARNING_SEC === -1) return;
      if (!activities || !activities.length) {
        setWarningOn(false);
        return;
      }
      if (showTimeoutOverlay) return;

      if (DEBUG_MODE) console.log('Activities - useEffect [activities.length]', activities);

      // remove warning & reset last activity timestamp
      setWarningOn(false);
      setLastActivityTimestamp(moment(activities[activities.length - 1].timestamp));
    },
    [activities.length]
  );

  const clearTimer = () => {
    if (timerVar) {
      clearInterval(timerVar);
    }
  };

  const restartTimer = () => {
    clearTimer();

    const timerInterval = setInterval(() => {
      if (TIMEOUT_SEC === -1 || WARNING_SEC === -1) return;
      const currentTime = moment();
      if (DEBUG_MODE) {
        console.log('currentTime', moment(currentTime).format());
        console.log('lastActivity', moment(lastActivityTimestampRef.current).format());
      }

      // calc last activity was how long time ago (duration of the current silence)
      setDurationOfSilence(currentTime - lastActivityTimestampRef.current);

      // if warning is on, calculate remaining sec
      if (warningOnRef.current) {
        // remaining time = destination time - current time
        //                = (lastActivity time + timeoutSec*1000) - current time
        const remaining =
          (moment(lastActivityTimestampRef.current).add(TIMEOUT_SEC, 'seconds') - moment()) / 1000;
        setRemainingWarningSec(Math.ceil(remaining));
      }
    }, 1000);
    setTimerVar(timerInterval);
  };

  useEffect(
    () => {
      if (TIMEOUT_SEC === -1 || WARNING_SEC === -1) return;
      if (!activities || !activities.length) return;
      if (DEBUG_MODE) {
        console.log('Activities - useEffect [showTimeoutOverlay]', showTimeoutOverlay, activities);
      }

      // remove warning & reset last activity timestamp
      setWarningOn(false);
      setLastActivityTimestamp(moment(activities[activities.length - 1].timestamp));

      // timer reset
      if (!showTimeoutOverlay) {
        restartTimer();
      }
    },
    [showTimeoutOverlay]
  );

  useEffect(() => {
    if (DEBUG_MODE) console.log('sessionConfig', sessionConfig);

    restartTimer();

    return () => clearTimer();
  }, []);

  useEffect(
    () => {
      if (warningOn) return;
      if (!lastActivityTimestamp) return;
      if (!activities || !activities.length) return;
      if (DEBUG_MODE) console.log('useEffect [durationOfSilence]', durationOfSilence);
      if (durationOfSilence >= (TIMEOUT_SEC - WARNING_SEC) * 1000) {
        if (durationOfSilence >= TIMEOUT_SEC * 1000) {
          if (!showTimeoutOverlay) {
            setWarningOn(false);
            setShowModalConfirm(false);
            setShowTimeoutOverlay(true);
          } else {
            // already timedout => timeout overlay
          }
        } else if (showTimeoutOverlay) {
          // already timedout => timeout overlay
        } else {
          // show warning
          setWarningOn(true);
          // remaining display sec = timeoutSec - warningSec
          setRemainingWarningSec(TIMEOUT_SEC - WARNING_SEC);
        }
      }
    },
    [durationOfSilence]
  );

  useEffect(
    () => {
      if (DEBUG_MODE) console.log('useEffect [remainingWarningSec]', remainingWarningSec);
      if (!lastActivityTimestamp) return;
      if (remainingWarningSec <= 0) {
        setWarningOn(false);
        setShowModalConfirm(false);
        setShowTimeoutOverlay(true);
      }
    },
    [remainingWarningSec]
  );

  const secondsToString = secs => {
    if (secs === 0) return '0 second';

    const minutes = Math.floor(secs / 60);
    let result = '';
    if (minutes > 0) {
      if (minutes === 1) {
        result = '1 minute';
      } else {
        result = `${minutes} minutes`;
      }
    }
    const seconds = secs % 60;
    if (seconds > 0) {
      if (result !== '') result += ' ';
      if (seconds === 1) {
        result += `${seconds} second`;
      } else {
        result += `${seconds} seconds`;
      }
    }
    return result;
  };

  const msg = sessionConfig.warningText
    ? sessionConfig.warningText.replace('{Counter}', secondsToString(remainingWarningSec))
    : secondsToString(remainingWarningSec);

  return (
    <div style={{ zIndex: '2000' }}>
      <Warning message={msg} showMessage={warningOn} />
    </div>
  );
};

export default WarningBeforeTimeout;



// WEBPACK FOOTER //
// ./src/components/ChatPanel/WarningBeforeTimeout.js